import store from '@/store'
const setting = () => import(/* webpackChunkName: "setting" */ '@/views/setting')
const waterLevel = () => import(/* webpackChunkName: "setting" */ '@/views/setting/water-level.vue')
const autoDiving = () => import(/* webpackChunkName: "setting" */ '@/views/setting/auto-diving.vue')
const replenishment = () => import(/* webpackChunkName: "setting" */ '@/views/setting/replenishment.vue')
const miscellaneous = () => import(/* webpackChunkName: "setting" */ '@/views/setting/miscellaneous.vue')
const year_zodiac = () => import(/* webpackChunkName: "setting" */ '@/views/setting/year_zodiac.vue')
const otherSiteList = () => import(/* webpackChunkName: "otherSiteList" */ '@/views/setting/otherSiteList')
const announcement = () => import(/* webpackChunkName: "announcement" */ '@/views/setting/announcement')
const settingLeading = {
  path: 'setting',
  name: 'setting',
  meta: { title: '系统设定', Submenu: true, menuOpenid: "11" },
  component: setting,
  redirect: '/main/:GD/setting/water-level',
  beforeEnter: (to, from, next) => {
    if (store.getters.getpermission.system[2] != '1') return next({ name: 'no-permission', params: to.params })
    next()
  },
  children: [
    {
      path: 'water-level',
      component: waterLevel,
      name: 'water-level',
      meta: { title: '水位设置' }
    },
    {
      path: 'auto-diving',
      name: 'auto-diving',
      component: autoDiving,
      meta: { title: '自动跳水设定(高管)' },
    },
    {
      path: 'auto-diving-all',
      name: 'auto-diving-all',
      component: autoDiving,
      meta: { title: '自动跳水设定(各站)' },
    },
    {
      path: 'replenishment',
      component: replenishment,
      name: 'replenishment',
      meta: { title: '补货设定' }
    },
    {
      path: 'miscellaneous',
      name: 'miscellaneous',
      component: miscellaneous,
      meta: { title: '杂项' },
    },
    {
      path: 'year_zodiac',
      name: 'year_zodiac',
      component: year_zodiac,
      meta: { title: '年度生肖' },
    },
    {
      path: 'otherSiteList',
      name: 'otherSiteList',
      component: otherSiteList,
      meta: { title: '額外站点設定' },
    },
    {
      path: 'announcement',
      name: 'announcement',
      component: announcement,
      meta: { title: '公告' },
    },
  ]
}
export default settingLeading